module.exports = __webpack_public_path__ + "assets/img/tx23g.6d39b7c7.jpg";